import React, { FunctionComponent, useEffect } from 'react';
import ModalPage from '@/components/layout/ModalPage';

import Row from '@/components/layout/Row';
import Text from '@/components/typography/Text';
import Col from '@/components/layout/Col';
import LogInOrSignUpForm from '@/components/authorization/LogInOrSignUpForm';
import authModalTitleFromSignUpState from '@/utility/signUp/authModalTitleFromSignUpState';
import VerticallySpacedDivider from '@/components/layout/VerticallySpacedDivider';
import useSignUpWizard from '@/hooks/useSignUpWizard';

interface IProps {
  logInOnly?: boolean;
}

const AuthModalPage: FunctionComponent<IProps> = ({ logInOnly = false }) => {
  const { signUpUser } = useSignUpWizard();
  const back = () => {
    // Redirect to Home page if user wants to exit Auth modal
    window.location.href = '/';
  };

  // This ensures that we do a full page refresh iuf the user is fully confirmed since this means that the user should be authenticated
  useEffect(() => {
    if (signUpUser?.signUpState === 'account_fully_confirmed') {
      globalThis?.window.location.reload();
    }
  }, [signUpUser?.signUpState]);

  const title = authModalTitleFromSignUpState(signUpUser?.signUpState);

  return (
    <ModalPage title={title} onCancel={back} size="medium">
      <Row>
        <Col span={24}>
          <div style={{ marginLeft: 10, marginRight: 10 }}>
            <Text>
              Moment offers true instant pricing, not just a contact form for someone to call you. An account is
              required to see instant results.
            </Text>
            <VerticallySpacedDivider />
          </div>
        </Col>
      </Row>
      <LogInOrSignUpForm logInOnly={logInOnly} />
    </ModalPage>
  );
};

export default AuthModalPage;
